import {
	GET_CATEGORIES, CREATE_CATEGORIES, UPDATE_CATEGORIES, GET_ERRORS, ACTIVATE_CATEGORIES, DEACTIVATE_CATEGORIES
} from './types';
import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';


const URL_GETCATEGORIES         = process.env.REACT_APP_API_URL + services.getCategories;
const URL_ADDCATEGORIES         = process.env.REACT_APP_API_URL + services.addCategories;
const URL_PATCH_CATEGORIES      = process.env.REACT_APP_API_URL + services.updateCategories;
const URL_DEACTIVATE_CATEGORIES = process.env.REACT_APP_API_URL + services.deactivateCategories;
const URL_ACTIVATE_CATEGORIES   = process.env.REACT_APP_API_URL + services.activateCategories;

export const getCategories = () => dispatch => {

	axios
		.get(URL_GETCATEGORIES)
		.then(res => {
			dispatch({
				type: GET_CATEGORIES,
				payload: {
					message: res.data.result
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const createCategories = (name, img_b64, extension, subcategories) => dispatch => {
	const data = {
		'category': {
			'name': name,
			'subcategories': subcategories,
			'img_b64': img_b64,
			'extension': extension
		}
	}


	axios.post(URL_ADDCATEGORIES, data)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: CREATE_CATEGORIES,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)

			})
		});
}

export const updateCategories = (id, name, img_b64, extension, subcategories) => dispatch => {
	const data = {
		'category': {
			'_id': id,
			'name': name,
			'subcategories': subcategories,
			'img_b64': img_b64,
			'extension': extension
		}
	}


	axios.put(URL_PATCH_CATEGORIES, data)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: UPDATE_CATEGORIES,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const deactivateCategories = (id) => dispatch => {

	let url = URL_DEACTIVATE_CATEGORIES + id;

	axios.delete(url)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: DEACTIVATE_CATEGORIES,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const activateCategories = (id) => dispatch => {

	let url = URL_ACTIVATE_CATEGORIES + id;

	axios.put(url)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: ACTIVATE_CATEGORIES,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}